import { render } from "./ArtSection.vue?vue&type=template&id=b0e7c52c"
import script from "./ArtSection.vue?vue&type=script&lang=js"
export * from "./ArtSection.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__